module.exports = __webpack_public_path__ + "img/38.2ee45769.jpg";